import { BannerResponse } from "@/api";

export function isBannerVisible(banner: BannerResponse | null | undefined): boolean {
  if (!banner) {
    return false;
  }

  const currentTime = Date.now();

  return banner.bannerStartUtc.getTime() <= currentTime && banner.maintenanceStartUtc.getTime() > currentTime;
}
